import { defineAsyncComponent } from 'vue';

import { toPlugin, type ComponentType, type Plugin } from '@bv/helpers/components';

export const audioComponentsArray: ComponentType[] = [
  {
    name: 'BvAudioPlayer',
    component: defineAsyncComponent(() => import('@bv/components/audio/player/BvAudioPlayer.vue')),
  },
  {
    name: 'BvAudioPlayerModal',
    component: defineAsyncComponent(() => import('@bv/components/audio/player/modal/BvAudioPlayerModal.vue')),
  },
];

export const audio: Plugin<[]> = toPlugin(audioComponentsArray);
